// utils/seoHelper.js
const BASE_URL = "https://tap2cash.in";
const API_BASE_URL = "https://app.tap2cash.in";
const DEFAULT_IMAGE = `https://app.tap2cash.in/assets/logo.png`;
const COMPANY_NAME = "Selltech E-Waste Management Solution Pvt Ltd";

export const generateSEOMetaTags = (seoData) => {
  const metaTags = {
    title: seoData.title,
    meta: [
      { name: "description", content: seoData.description },
      { name: "keywords", content: seoData.keywords },
      { name: "author", content: COMPANY_NAME },
      {
        name: "robots",
        content: seoData.noIndex ? "noindex, nofollow" : "index, follow",
      },
      { name: "theme-color", content: "#4CCD64FF" },
      { name: "viewport", content: "width=device-width, initial-scale=1.0" },
      { property: "og:title", content: seoData.title },
      { property: "og:description", content: seoData.description },
      { property: "og:image", content: seoData.ogImage || DEFAULT_IMAGE },
      { property: "og:url", content: seoData.canonical || BASE_URL },
      { property: "og:type", content: "website" },
      { property: "og:site_name", content: "Tap2Cash" },
      { property: "og:locale", content: "en_IN" },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: seoData.title },
      { name: "twitter:description", content: seoData.description },
      { name: "twitter:image", content: seoData.ogImage || DEFAULT_IMAGE },
    ],
    link: [
      { rel: "canonical", href: seoData.canonical || BASE_URL },
      { rel: "icon", href: `https://app.tap2cash.in/favicon.ico` },
      { rel: "apple-touch-icon", href: `https://app.tap2cash.in/favicon.ico` },
    ],
  };

  if (seoData.noIndex) {
    metaTags.meta.push({ name: "robots", content: "noindex, nofollow" });
  }

  return metaTags;
};
